import TRANSITIONS from './utils/transitions'

export default {
  autocomplete: {
    root: ({ props }) => ({
        class: [
            'w-full relative inline-flex',
            {
                'opacity-60 select-none pointer-events-none cursor-default': props.disabled
            },
            { 'w-full': props.multiple }
        ]
    }),
    container: {
        class: [
            'm-0 list-none cursor-text overflow-hidden flex items-center flex-wrap w-full',
            'px-3 py-2 gap-2',
            'font-sans text-base text-gray-700 border border-gray-300 transition duration-200 ease-in-out appearance-none rounded-md',
            'focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] hover:border-blue-500 focus:outline-none'
        ]
    },
    inputtoken: {
        class: ['py-0.375rem px-0', 'flex-1 inline-flex']
    },
    loadingicon: ({ props }) => {
      return { class: ['absolute right-0 mr-4 top-1/2 -mt-[0.4rem] animate-spin', !props.loading ? 'hidden' : '']}
    },
    input: ({ props }) => ({
        class: [
            'w-full font-sans text-base text-neutral-700 bg-white m-0 p-3',
            'transition-colors duration-200 appearance-none',
            'rounded-[10px] focus:ring-1 focus:ring-royal-400 outline-none',
            '!border border-neutral-600 hover:border-royal-300',
            { 'rounded-tr-none rounded-br-none': props.dropdown },
            {
                'font-sans text-base text-gray-700 p-3 border':
                    !props.multiple,
                'font-sans text-base text-gray-700 border-0 bg-transparent m-0 p-0 rounded-none w-full': props.multiple
            }
        ]
    }),
    token: {
        class: ['py-1 px-2 mr-2 bg-gray-300 text-gray-700 rounded-full', 'cursor-default inline-flex items-center']
    },
    dropdownbutton: {
        root: 'rounded-tl-none rounded-bl-none'
    },
    panel: {
        class: ['bg-white text-gray-700 border-0 rounded-md shadow-lg', 'max-h-[200px] overflow-auto']
    },
    list: 'py-3 list-none m-0',
    item: ({ context }) => ({
        class: [
            'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
            'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
            'hover:text-gray-700 hover:bg-gray-200',
            {
                'text-gray-700': !context.focused && !context.selected,
                'bg-gray-300 text-gray-700': context.focused && !context.selected,
                'bg-blue-500 text-blue-700': context.focused && context.selected,
                'bg-blue-50 text-blue-700': !context.focused && context.selected
            }
        ]
    }),
    itemgroup: {
        class: ['m-0 p-3 text-gray-800 bg-white font-bold', 'cursor-auto']
    },
    transition: TRANSITIONS.overlay
}
}
